import Radio from '@components/v2/form/Radio/Radio';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../translation/TranslationContext';
import { SignUpUserMode } from './types/signUp.types';

interface OptionLabelProps {
  titleKey: LangEnum;
  helperKey: LangEnum;
}

const OptionLabel = ({ titleKey, helperKey }: OptionLabelProps) => {
  const { translate } = useTranslation();

  return (
    <Box>
      <Typography>{translate(titleKey)}</Typography>
      <Typography color="textSecondary" variant="body2">
        {translate(helperKey)}
      </Typography>
    </Box>
  );
};

interface AccessModeRadioGroupProps {
  value: SignUpUserMode;
  onChange: (mode: SignUpUserMode) => void;
}

const AccessModeRadioGroup = ({ value, onChange }: AccessModeRadioGroupProps) => {
  const { translate } = useTranslation();

  return (
    <Stack spacing={2}>
      <Typography>{translate(LangEnum.SIGN_UP_ACCESS_MODE_LABEL)}</Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        role="radiogroup"
        aria-label={translate(LangEnum.SIGN_UP_ACCESS_MODE_LABEL)}
      >
        <Radio
          checked={value === 'NEW'}
          value="NEW"
          name="accessMode"
          onChange={() => onChange('NEW')}
          label={
            <OptionLabel
              titleKey={LangEnum.SIGN_UP_ACCESS_MODE_NEW}
              helperKey={LangEnum.SIGN_UP_ACCESS_MODE_NEW_HINT}
            />
          }
        />
        <Radio
          checked={value === 'EXISTENT'}
          value="EXISTENT"
          name="accessMode"
          onChange={() => onChange('EXISTENT')}
          label={
            <OptionLabel
              titleKey={LangEnum.SIGN_UP_ACCESS_MODE_EXISTENT}
              helperKey={LangEnum.SIGN_UP_ACCESS_MODE_EXISTENT_HINT}
            />
          }
        />
      </Stack>
    </Stack>
  );
};

export default AccessModeRadioGroup;
